import { render } from "./Style.vue?vue&type=template&id=5761d645"
import script from "./Style.vue?vue&type=script&lang=js"
export * from "./Style.vue?vue&type=script&lang=js"
script.render = render

export default script